/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`First race of season - no historical data`)
};

const es_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primera carrera de la temporada - sin datos históricos`)
};

const de_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erstes Rennen der Saison — keine historischen Daten`)
};

const nl_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eerste race van het seizoen — geen historische gegevens`)
};

const fr_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Première course de la saison — aucune donnée historique`)
};

const it_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prima gara della stagione — nessun dato storico`)
};

const pt_br2_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira corrida da temporada — sem dados históricos`)
};

const pt_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Primeira corrida da época — sem dados históricos`)
};

const ja_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`シーズン最初のレース — 過去データなし`)
};

const zh_f1_budget_first_race = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本赛季第一场比赛 — 无历史数据`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_budget_first_race = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_budget_first_race(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_budget_first_race", locale)
	if (locale === "en") return en_f1_budget_first_race(inputs)
	if (locale === "es") return es_f1_budget_first_race(inputs)
	if (locale === "de") return de_f1_budget_first_race(inputs)
	if (locale === "nl") return nl_f1_budget_first_race(inputs)
	if (locale === "fr") return fr_f1_budget_first_race(inputs)
	if (locale === "it") return it_f1_budget_first_race(inputs)
	if (locale === "pt-BR") return pt_br2_f1_budget_first_race(inputs)
	if (locale === "pt") return pt_f1_budget_first_race(inputs)
	if (locale === "ja") return ja_f1_budget_first_race(inputs)
	return zh_f1_budget_first_race(inputs)
};